import React from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-table-6/react-table.css';
import PasswordHeader from 'Screens/Credentials/components/Table/components/Password/PasswordHeader';
import GenericCell from 'Screens/Credentials/components/Table/components/GenericCell';
import PasswordCell from 'Screens/Credentials/components/Table/components/Password/PasswordCell';
import ActionsCell from 'Screens/Credentials/components/Table/components/ActionsCell';
import OwnedCell from 'Screens/Credentials/components/Table/components/OwnedCell';
import OpeningCell from 'Screens/Credentials/components/Table/components/OpeningCell';

/**
 * Credentials table of the vulnerability detail (General tab).
 * ctx: `{ hidePass, setHidePass, isFetching }`
 */
const vulnDetailCredentialsSchema = {
  id: 'vulnDetailCredentials',
  ordering: {},
  columns: [
    {
      header: () => (
        <FormattedMessage id="credentials.table.columns.endpoint" />
      ),
      id: 'endpoint',
      accessor: 'endpoint',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 158,
      minWidth: 158,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => (
        <GenericCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'endpoint' }
        />
      )
    },
    {
      header: () => (
        <FormattedMessage id="credentials.table.columns.username" />
      ),
      id: 'username',
      accessor: 'username',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 168,
      minWidth: 168,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => (
        <OpeningCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'username' }
          isVulnDetail
        />
      )
    },
    {
      header: (_, { hidePass, setHidePass }) => (
        <PasswordHeader hidePass={ hidePass } setHidePass={ setHidePass } />
      ),
      id: 'password',
      accessor: 'password',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 138,
      minWidth: 138,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching, hidePass }) => (
        <PasswordCell
          showSkeleton={ isFetching }
          rowInfo={ rowInfo }
          field={ 'password' }
          hidePass={ hidePass }
        />
      )
    },
    {
      header: () => <FormattedMessage id="credentials.table.columns.owned" />,
      id: 'owned',
      accessor: 'owned',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 70,
      minWidth: 70,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => (
        <OwnedCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'owned' } isVulnDetail />
      )
    },
    {
      id: 'actions',
      accessor: 'actions',
      visible: true,
      sortable: false,
      resizable: false,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <ActionsCell showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }
  ]
};

export default vulnDetailCredentialsSchema;
